import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';

interface Props {
  lang: 'en' | 'ru' | 'it' | 'fr';
}

const goodSkills = ['PHP', 'MySQL', 'Postgres'];
const okSkills = ['Golang', 'Ubuntu', 'JavaScript', 'React', 'CSS', 'HTML', 'MongoDB', 'Redis', 'RabbitMQ'];

export default function Technology({ lang }: Props) {
  const { t } = useTranslation('technology');
  const tc = useTranslation('common').t;

  return (
    <Layout lang={lang}>
      <div className="blog-post">
        <h2 className="blog-post-title">{t('title')}</h2>
        <p className="blog-post-meta">
          {t('date')} &nbsp;|&nbsp; <Link to={lang === 'en' ? '/' : `/${lang}`}>{tc('mainPage')}</Link>
          &nbsp;|&nbsp; <a href="https://github.com/microbusiness" target="_blank" rel="noopener noreferrer">{tc('github')}</a>
        </p>
        <hr />

        <h3>{t('bigLetters.title')}</h3>
        <h5 className="text-muted">{t('bigLetters.subtitle')}</h5>

        <p>{t('bigLetters.p1')}</p>
        <p>{t('bigLetters.p2')}</p>
        <p>
          {t('bigLetters.p3')}
        </p>

        <hr />

        <h4>{t('good.title')} <small className="text-muted">{t('good.subtitle')}</small></h4>
        <div className="d-flex flex-wrap mb-3" style={{ gap: '8px' }}>
          {goodSkills.map(s => (
            <span key={s} className="badge badge-primary" style={{ fontSize: '1rem', padding: '8px 14px' }}>{s}</span>
          ))}
        </div>

        <h4>{t('ok.title')} <small className="text-muted">{t('ok.subtitle')}</small></h4>
        <div className="d-flex flex-wrap" style={{ gap: '8px' }}>
          {okSkills.map(s => (
            <span key={s} className="badge badge-success" style={{ fontSize: '1rem', padding: '8px 14px' }}>{s}</span>
          ))}
        </div>
      </div>
    </Layout>
  );
}
